<template src="../templates/normal_fcont_1.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import CreatorProfileItsuka from "../components/CreatorProfileItsuka"
import AppDownloadCreative from "../components/AppDownloadCreative"
import AppDownloadiPrint from "../components/AppDownloadiPrint"
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel';
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide ,FuncSearchGalleryQR,CreativePrint,
   CreatorProfileItsuka,AppDownloadCreative,AppDownloadiPrint,AppDownloadPhotoPlus,AppDownloadSmartPanel
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  methods: {
  },
  metaInfo(){
    return {
    title: this.$store.state.messages.messages['1-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['1-2']}
    ]
    }
  }
};
</script>
<style />


